// var adiInit = "1", adiRVO = true;
// var adiFunc = null;
// setTimeout("rTapShowNumber()", 1000);
// if (rTapCookiesEnabled()) {
//     (function () {
//         var adiSrc = document.createElement("script");
//         adiSrc.type = "text/javascript";
//         adiSrc.async = true;
//         adiSrc.src = ("https:" == document.location.protocol ? "https://static-ssl" : "http://static-cdn") + ".responsetap.com/static/scripts/rTapTrack.min.js";
//         if (adiSrc.addEventListener) adiSrc.addEventListener("error", function () {
//             rTapShowNumber()
//         }, !0), adiSrc.addEventListener("load", function () {
//             setTimeout("rTapShowNumber()", 350)
//         }, !0);
//         else if (typeof adiSrc.onreadystatechange !== "undefined") adiSrc.onreadystatechange = function () {
//             adiSrc.readyState == "loaded" && setTimeout("rTapShowNumber()", 350)
//         };
//         var s = document.getElementsByTagName("script")[0];
//         s.parentNode.insertBefore(adiSrc, s);
//     })();
// } else {
//     rTapShowNumber();
// }

function rTapCookiesEnabled() {
    if (typeof navigator.cookieEnabled === "undefined") return document.cookie = "testcookie", ~document.cookie.indexOf("testcookie"); else if (!navigator.cookieEnabled) return !1;
    return !0
}

function rTapShowNumber() {
    for (var b = document.getElementsByTagName("*"), d = b.length, a = 0; a < d; a++) {
        var c = b[a];
        // if (~c.className.indexOf("adinsightNumber")) c.style.visibility = "visible";
        // if (~c.className.indexOf("rTapNumber")) c.style.visibility = "visible";
    }
}

function adInsightPostReplacement() {
    rTapShowNumber()
};

/**
 * Changes the selected elements state to active
 *
 * @param object event The event object
 * @return void
 */
var _setActive = function (event) {
    event.preventDefault();
    event.stopPropagation();

    $($(this).parent().find('.footer__geomenu')).addClass('active');
}

/**
 * Closes the popover menu
 *
 * @return void
 */
var _closeMenu = function() {
    $('.footer__geomenu').removeClass('active');
}


jQuery(document).ready(function ($) {
    $('.js-geo-menu-toggle > p').on('click', _setActive);
    $(window).click(_closeMenu);
});


// $('.js-geo-menu-toggle > p').on('click', _setActive);
// $('.footer__geomenu a').on('click', _changeState);
// $(window).click(_closeMenu);
//
